/**
 * In-memory store for the OTP session token.
 * Keeps otp_token out of URL params (avoids leaking via referrers/logs on web).
 */
let _otpToken: string | null = null;

export const otpStore = {
  set: (token: string) => { _otpToken = token; },
  get: () => _otpToken,
  clear: () => { _otpToken = null; },
};
